import React from 'react';
import { motion } from 'framer-motion';
import { Lock, AlertTriangle, Zap, FileText, ShieldCheck } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
import { CountdownTimer } from './CountdownTimer';
export function OfferBlock() {
  const handleBuyClick = () => {
    trackAddToCart();
    window.location.href = 'https://clavedepaz.com/cart/44115100106851:1';
  };
  return <section id="offer" className="bg-navy py-24 px-6 border-y border-slate-800/50 relative overflow-hidden" data-id="element-197">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-5 pointer-events-none" data-id="element-198">
        <div className="absolute top-[20%] left-[50%] -translate-x-1/2 w-[80%] h-[80%] rounded-full bg-red-600 blur-[150px]" data-id="element-199"></div>
      </div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-200">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white p-8 md:p-12 rounded-2xl shadow-2xl shadow-red-900/20 border-2 border-red-100 relative" data-id="element-201">
          <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-red-600 text-white px-6 py-1.5 rounded-full text-sm font-bold flex items-center gap-2 shadow-lg whitespace-nowrap" data-id="element-202">
            <span className="w-2 h-2 rounded-full bg-white animate-ping" data-id="element-203"></span>
            OFERTA POR TIEMPO LIMITADO
          </div>

          <h2 className="font-playfair text-3xl md:text-4xl font-bold text-slate-900 mb-4 mt-4" data-id="element-204">
            Qué decirle a tu ex sin empeorar el conflicto (y sin afectar a tus
            hijos).
          </h2>

          <p className="text-lg text-slate-600 mb-6 max-w-xl mx-auto" data-id="element-205">
            Aprendé exactamente cómo responder en momentos difíciles, evitar
            discusiones innecesarias y mantener el control cuando más importa.
          </p>

          <div className="bg-slate-50 rounded-xl p-6 mb-8 border border-slate-100" data-id="element-206">
            <div className="text-sm font-bold text-red-600 uppercase tracking-wider mb-2 flex items-center justify-center gap-2" data-id="element-207">
              <AlertTriangle size={16} data-id="element-208" />
              La oferta termina pronto
            </div>

            <CountdownTimer data-id="element-209" />

            <p className="text-sm text-slate-500 font-medium mt-2" data-id="element-210">
              Cuando el contador llegue a 0, el precio vuelve a $24.999
            </p>
          </div>

          <div className="mb-10" data-id="element-211">
            <div className="flex flex-col items-center justify-center gap-1 mb-3" data-id="element-212">
              <div className="text-4xl md:text-5xl text-slate-400 line-through font-bold mb-1 decoration-red-500/50 decoration-4" data-id="element-213">
                Valor real: $24.999 ARS
              </div>
              <div className="text-6xl md:text-7xl font-bold text-green-600 font-sans leading-none flex items-center gap-3" data-id="element-214">
                <span className="text-3xl text-slate-600 font-medium" data-id="element-215">
                  Hoy:
                </span>{' '}
                $9,999 ARS
              </div>
            </div>
            <div className="inline-flex items-center gap-2 bg-amber-100 text-amber-800 px-3 py-1 rounded-full text-sm font-bold mb-4 mt-2" data-id="element-216">
              <FileText size={14} data-id="element-217" />
              Formato PDF · Descarga inmediata · Acceso de por vida
            </div>
          </div>

          <button onClick={handleBuyClick} className="bg-green-600 hover:bg-green-700 text-white font-bold text-2xl md:text-3xl py-6 px-8 rounded-xl shadow-xl shadow-green-600/30 transition-all transform hover:scale-105 active:scale-95 w-full mb-4 border-b-4 border-green-800" data-id="element-218">
            COMPRAR AHORA (Acceso inmediato)
          </button>

          <p className="text-sm text-slate-500 mb-6 font-medium" data-id="element-219">
            Ebook digital (PDF). No es libro físico. Recibirás el acceso
            inmediatamente después del pago.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6 text-sm text-slate-600 font-medium" data-id="element-220">
            <div className="flex items-center justify-center gap-2 bg-slate-50 py-2 rounded-lg" data-id="element-221">
              <ShieldCheck size={16} className="text-green-600" data-id="element-222" />
              <span data-id="element-223">Pago 100% seguro</span>
            </div>
            <div className="flex items-center justify-center gap-2 bg-slate-50 py-2 rounded-lg" data-id="element-224">
              <Zap size={16} className="text-amber-500" data-id="element-225" />
              <span data-id="element-226">Acceso instantáneo</span>
            </div>
            <div className="flex items-center justify-center gap-2 bg-slate-50 py-2 rounded-lg" data-id="element-227">
              <FileText size={16} className="text-blue-500" data-id="element-228" />
              <span data-id="element-229">PDF descargable</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}